export default "__VITE_ASSET__uv$Nn$H9__"